import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["resourceSelect", "valueSelect"];
  static values = { resources: Array };

  groupLabels = {
    resource_data: "Datos del recurso",
    custom_fields: "Campos personalizados",
  };

  connect() {
    this.resourceSelectTargets.forEach((resourceSelect, index) => {
      const valueSelect = this.valueSelectTargets[index];
      const currentValue = valueSelect.dataset.currentValue || "";
      this.populateValueOptions(resourceSelect.value, valueSelect, currentValue);
    });
  }

  updateValues(event) {
    const resourceSelect = event.currentTarget;
    const index = this.resourceSelectTargets.indexOf(resourceSelect);
    const valueSelect = this.valueSelectTargets[index];
    this.populateValueOptions(resourceSelect.value, valueSelect, "");
  }

  populateValueOptions(resourceName, valueSelect, selectedKey) {
    valueSelect.innerHTML =
      '<option value="">— Seleccione un valor —</option>';

    if (!resourceName) return;

    const resource = this.resourcesValue.find((r) => r.name === resourceName);
    if (!resource) return;

    Object.entries(resource.values).forEach(([groupKey, items]) => {
      if (!items || items.length === 0) return;

      const optgroup = document.createElement("optgroup");
      optgroup.label = this.groupLabels[groupKey] || groupKey;

      items.forEach(({ key, label }) => {
        const option = new Option(label, key, false, key === selectedKey);
        optgroup.appendChild(option);
      });

      valueSelect.appendChild(optgroup);
    });
  }
}
